import { render, staticRenderFns } from "./KgjtWebsiteConsulting.vue?vue&type=template&id=04e58929&scoped=true&"
import script from "./KgjtWebsiteConsulting.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteConsulting.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteConsulting.vue?vue&type=style&index=0&id=04e58929&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e58929",
  null
  
)

export default component.exports